export class Attribute {
  constructor(public id: number, public value: string) {}
}
